export default __webpack_public_path__ + "static/bahetle-215813e52cdc4fbde848601460b62501.png";